module.exports = __webpack_public_path__ + "static/media/1. Avanzar, Mixta en tela, 100 x 100 cm, 2016.jpg copy.909da622.png";